import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    CustomInput,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    InputGroupText,
    InputGroupAddon,
    InputGroup,
} from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import moment from 'moment';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
import {
    gAPI_Vouchers_By_Id,
    gAPI_QuestionOptionList,
    gAPI_RatePlans_List,
    gAPI_Rooms_List,
    API_Xola,
} from '../../../../../../../constants/APIs';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CustomSelectInput from '../../../../../../../components/common/CustomSelectInput';
import Select from 'react-select';
import RoomSettings from './RoomSettings';
import StandaloneCurrency from '../../../../../../../data/StandaloneCurrency';
const quillModules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
        ],
        ['link', 'image'],
        ['clean'],
    ],
};

const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
];
function BuyOptionForm({
    visible,
    toggle,
    formLabel,
    submit,
    voucherName,
    updateVoucherData,
    id, extractData,
    propertyId,
    locale,
    optionId,
    update,
    amadeus,xolaIntegration
}) {
    const Weekdays = [
        { value: 'Monday', name: 'Monday' },
        { value: 'Tuesday', name: 'Tuesday' },
        { value: 'Wednesday', name: 'Wednesday' },
        { value: 'Thursday', name: 'Thursday' },
        { value: 'Friday', name: 'Friday' },
        { value: 'Saturday', name: 'Saturday' },
        { value: 'Sunday', name: 'Sunday' },
    ];
    const [voucherData, setVoucherData] = useState(
        updateVoucherData || {
            groupId: getGroupID(),
            propertyId: propertyId,
            showDetails: false,
            name: [
                {
                    statement: '',
                    languageCode: locale,
                },
            ],
            introduction: [
                {
                    statement: '',
                    languageCode: locale,
                },
            ],
            details: [
                {
                    statement: '',
                    languageCode: locale,
                },
            ],
            conditions: [
                {
                    statement: '',
                    languageCode: locale,
                },
            ],
            status: 'Draft',
            price: 0,
            discountedPrice: 0,
            discount: 0,
            totalPurchaseLimit: 0,
            orderPurchaseLimit: 0,
            startDate: moment().format('YYYY-MM-DD'),
            expiryDate: moment().add(30, 'days').format('YYYY-MM-DD'),
            creator: 'Admin',
            sellingOptions: [],
            displayOrder: 1,
            searchTags: [],
            images: [],
            options: true,
            inventoryOptionLevel: false,
            giftEnabled: false,
            location: '',
            category: '',
            provider: '',
            includedItems: '',
            redeemOption: '',
        }
    );
    const [selectedTags, setselectedTags] = useState([]);
    const [tags, setTags] = useState([]);
    const [couponList,setCouponList]=useState([]);
    useEffect(() => {
        if(xolaIntegration!==undefined)
        {    
            AxiosAPI({
                methhod: 'get',
                url: `${API_Xola}/${xolaIntegration.id}/couponList?group_id=${getGroupID()}`,
            }).then((res) => {
                console.log(res.data.data);
                setCouponList(res.data.data);
            });
        }
        if (id !== undefined) {
            AxiosAPI({
                methhod: 'get',
                url: `${gAPI_Vouchers_By_Id}/${id}`,
            })
                .then((res) => {
                    if (!update) {
                        var options = [];
                        try {
                            Weekdays.map((item) =>
                                options.push({
                                    label: item.name,
                                    value: item.value,
                                    key: item.value,
                                })
                            );
                        } finally {
                        }
                        setTags(options);
                        setVoucherData({
                            ...voucherData,
                            sellingOptions: [
                                {
                                    iscreate: true,
                                    option: '',
                                    price: 0,
                                    discountedPrice: 0,
                                    discount: 0,
                                    totalPurchaseLimit: 0,
                                    orderPurchaseLimit: 0,
                                    status: 'Active',
                                    currencies: [],
                                    roomSettings: {
                                        noOfChildren: 0,
                                        noOfAdults: 0,
                                        noOfNights: 0,
                                        promoCode: '',
                                        noOfRooms:0,
                                        couponId:'-1',
                                        noOfAdultsOperator:"equals",
                                        noOfChildrenOperator:"equals",
                                        bookingStartDate: moment().format('YYYY-MM-DD'),
                                        bookingEndDate: moment().format('YYYY-MM-DD'),
                                        travelStartDate: '0001-01-01',
                                        travelEndDate:'0001-01-01',
                                        redeemOption: 2,
                                        days: 'Monday,Sunday,Saturday,Tuesday,Wednesday,Thursday,Friday'
                                    },
                                    displayOrder: 1,
                                    instruction: [
                                        {
                                            statement: '',
                                            languageCode: locale,
                                        },
                                    ],
                                    details:res.data.details,
                                    url: '',
                                    id: createUUID(),
                                },
                            ],
                        });
                    } else {
                        let option = res.data.sellingOptions.filter(
                            (s) => s.id === optionId
                        );
                        res.data.sellingOptions = [option[0]];
                        setVoucherData(res.data);
                        var options = [];
                        try {
                            Weekdays.map((item) =>
                                options.push({
                                    label: item.name,
                                    value: item.value,
                                    key: item.value,
                                })
                            );
                        } finally {
                        }
                        setTags(options);
                        var selectedTags = [];
                        try {
                            options.map((item) => {
                                if (option[0].roomSettings.days !== '' && option[0].roomSettings.days.split(',').filter(f => f === item.value).length > 0) {
                                    selectedTags.push(item)
                                }
                            });
                        } finally {
                        }
                        setselectedTags(selectedTags);
                    }
                })
            // .catch((err) => console.log('err', err));
        }
    }, [id]);

    const getLocalStatement = (statements) => {
        if (statements !== undefined && statements.length > 0) {
            const index = statements.findIndex((m) => m.languageCode === locale);
            if (index === -1) {
                const englishIndex = statements.findIndex(
                    (m) => m.languageCode === 'en'
                );
                if (englishIndex !== -1) {
                    return statements[englishIndex].statement;
                }
            } else {
                return statements[index].statement;
            }
        } else {
            return '';
        }
    };

    const handleInstruction = (source, data, optionId) => {
        if (source === 'user') {
            setVoucherData({
                ...voucherData,
                sellingOptions: voucherData.sellingOptions.map((m) => {
                    if (m.id === optionId) {
                        m.instruction = [
                            {
                                statement: data,
                                languageCode: locale,
                            },
                        ];
                    }
                    return m;
                }),
            });
        }
    };
    const handleDetails = (source, data, optionId) => {
        if (source === 'user') {
            setVoucherData({
                ...voucherData,
                sellingOptions: voucherData.sellingOptions.map((m) => {
                    if (m.id === optionId) {
                        m.details = [
                            {
                                statement: data,
                                languageCode: locale,
                            },
                        ];
                    }
                    return m;
                }),
            });
        }
    };


    const handleSubmit = () => {
        submit(voucherData);
        //toggle();
    };

    const createUUID = () => {
        const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
        return pattern.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    const handleOptionInputChange = (name, event, optionId) => {
        switch (name) {
            case 'option':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.option = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'showDetails':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.showDetails = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'price':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.price = event;
                            m.discountedPrice = Math.round(
                                parseFloat(event) -
                                (parseFloat(event) * parseFloat(m.discount)) / 100
                            );
                        }
                        return m;
                    }),
                });
                break;
            case 'discount':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.discount = event;
                            m.discountedPrice = Math.round(
                                parseFloat(m.price) -
                                (parseFloat(m.price) * parseFloat(event)) / 100
                            );
                        }
                        return m;
                    }),
                });
                break;
            case 'discountedPrice':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.discountedPrice = event;
                        }
                        return m;
                    }),
                });

                break;
            case 'totalPurchaseLimit':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.totalPurchaseLimit = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'status':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.status = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'orderPurchaseLimit':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.orderPurchaseLimit = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'displayOrder':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.displayOrder = event;
                        }
                        return m;
                    }),
                });
                break;

            case 'noOfAdults':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.noOfAdults = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'noOfChildren':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.noOfChildren = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'noOfNights':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.noOfNights = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'noOfRooms':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.noOfRooms = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'promoCode':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.promoCode = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'couponId':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.couponId = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'redeemOption':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.redeemOption = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'noOfChildrenOperator':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.noOfChildrenOperator = event;
                        }
                        return m;
                    }),
                });
                break;

            case 'noOfAdultsOperator':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.noOfAdultsOperator = event;
                        }
                        return m;
                    }),
                });
                break;

            case 'travelStartDate':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.travelStartDate = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'travelEndDate':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.travelEndDate = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'bookingStartDate':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.bookingStartDate = event;
                        }
                        return m;
                    }),
                });
                break;

            case 'bookingEndDate':

                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.bookingEndDate = event;
                        }
                        return m;
                    }),
                });
                break;
            case 'day':
                setVoucherData({
                    ...voucherData,
                    sellingOptions: voucherData.sellingOptions.map((m) => {
                        if (m.id === optionId) {
                            m.roomSettings.days = event + ",";
                        }
                        return m;
                    }),
                });
                break;
            default:
                break;
        }
    };
    const handleChangeTags = (tags, optionId) => {
        setselectedTags(tags);
        const tagsArr = tags.map((elem) => elem.value);
        tags.map((elem) => elem.value + ",");
        setVoucherData({
            ...voucherData,
            sellingOptions: voucherData.sellingOptions.map((m) => {
                if (m.id === optionId) {
                    m.roomSettings.days = tagsArr.toString();
                }
                return m;
            }),
        });
    };
    const handleAddIncludedItems = (name, optionId) => {
        setVoucherData({
            ...voucherData,
            sellingOptions: voucherData.sellingOptions.map((m) => {
                if (m.id === optionId) {
                    if (m.roomSettings.days.split(',').includes(name.trim(''))) {
                        let includeItemsList = m.roomSettings.days.split(',');
                        let itemsList = includeItemsList.filter((e) => e !== name);
                        m.roomSettings.days = itemsList.toString();
                    } else {
                        m.roomSettings.days = m.roomSettings.days + ',' + name;

                    }
                }
                return m;
            }),
        });

    }
    const handleAddCurrencies = (optionId) => {
        setVoucherData({
            ...voucherData,
            sellingOptions: voucherData.sellingOptions.map((m) => {
                if (m.id === optionId) {
                    let lst = [...m.currencies];
                    lst.push({
                        currency: 'USD',
                        price: 0,
                        discount: 0,
                        discountedPrice: 0,
                    });
                    m.currencies = lst;
                }
                return m;
            }),
        });

    }

    const handleRemoveCurrencies = (val, optionId) => {
        setVoucherData({
            ...voucherData,
            sellingOptions: voucherData.sellingOptions.map((m) => {
                if (m.id === optionId) {
                    let lst = [...m.currencies];
                    lst = lst.filter((f, index) => index !== val);
                    m.currencies = lst;
                }
                return m;
            }),
        });

    }

    const handleCurrencyPrice = (e, val, optionId) => {
        setVoucherData({
            ...voucherData,
            sellingOptions: voucherData.sellingOptions.map((m) => {
                if (m.id === optionId) {
                    let lst = [...m.currencies];
                    lst.map((l, index) => {
                        if (index === val) {
                            if (l.discount === 0) {
                                l.price = e.target.value;
                                l.discountedPrice = e.target.value;
                            } else {
                                l.price = e.target.value;
                                l.discountedPrice = e.target.value - ((e.target.value * l.discount) / 100);
                            }
                        }
                    });
                    m.currencies =lst;
                }
                return m;
            }),
        });
    }

    const handleCurrencyDiscount = (e, val, optionId) => {
        setVoucherData({
            ...voucherData,
            sellingOptions: voucherData.sellingOptions.map((m) => {
                if (m.id === optionId) {
                    let lst = [...m.currencies];
                    lst.map((l, index) => {
                        if (index === val) {
                            if (e.target.value === 0) {
                                l.discount = e.target.value;
                                l.discountedPrice = l.price;
                            } else {
                                l.discount = e.target.value;
                                l.discountedPrice = l.price - ((l.price * e.target.value) / 100);
                            }
                        }
                    });
                    m.currencies=lst;
                }
                return m;
            }),
        });
    }

    const handleCurrency = (e, val, optionId) => {
        setVoucherData({
            ...voucherData,
            sellingOptions: voucherData.sellingOptions.map((m) => {
                if (m.id === optionId) {
                    let lst = [...m.currencies];
                    lst.map((m, index) => {
                        if (index === val)
                            m.currency = e.target.value;
                    });
                    m.currencies = lst;
                }
                return m;
            }),
        });
    }
    return (
        <Fragment>
            <Modal
                isOpen={visible}
                toggle={toggle}
                size="lg"
                style={{ maxWidth: '1000px' }}
            >
                <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
                <ModalBody>
                    <Fragment>
                        {voucherData.options &&
                            voucherData.sellingOptions !== undefined &&
                            voucherData.sellingOptions.length > 0
                            ? voucherData.sellingOptions
                                .filter((m) => {
                                    if (
                                        update
                                            ? m.status !== 'Archived' &&
                                            (optionId !== undefined ? m.id === optionId : true)
                                            : m.iscreate == true && m.status !== 'Archived'
                                    ) {
                                        return m;
                                    }
                                })
                                .map((tariff, index) => (
                                    <Fragment>
                                        <Row key={`${tariff}~${index}`}>
                                            <Colxx sm={6} className="mb-3">
                                                <Label>Voucher</Label>
                                                <Input
                                                    disabled={true}
                                                    type="text"
                                                    name="option"
                                                    value={voucherName}
                                                />
                                            </Colxx>
                                            <Colxx sm={6} className="mb-3">
                                                <Label>Option</Label>
                                                <Input
                                                    required
                                                    type="text"
                                                    name="option"
                                                    value={tariff.option}
                                                    onChange={(event) =>
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }
                                                />
                                            </Colxx>
                                            <Colxx sm={3} className="mb-3">
                                                <Label>Price</Label>
                                                <Input
                                                    type="number"
                                                    min={0}
                                                    value={tariff.price}
                                                    name="price"
                                                    onChange={(event) =>
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }
                                                />
                                            </Colxx>
                                            <Colxx sm={3} className="mb-3">
                                                <Label>Discount</Label>
                                                <InputGroup>
                                                    <Input
                                                        type="number"
                                                        min={0}
                                                        value={tariff.discount}
                                                        name="discount"
                                                        onChange={(event) =>
                                                            handleOptionInputChange(
                                                                event.target.name,
                                                                event.target.value,
                                                                tariff.id
                                                            )
                                                        }
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText>%</InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </Colxx>
                                            <Colxx sm={3} className="mb-3">
                                                <Label>Price After Discount</Label>
                                                <Input
                                                    disabled={true}
                                                    type="number"
                                                    min={0}
                                                    value={tariff.discountedPrice}
                                                    name="discountedPrice"
                                                    onChange={(event) =>
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }
                                                />
                                            </Colxx>
                                            {/* {voucherData.redeemOption === 'BookMeBob' &&
                                        voucherData.category === 'Accommodation' ? (
                                        <Fragment>
                                          
                                            {tariff.roomSettings.id !== '' && (
                                                <Colxx sm={3} className="mb-3">
                                                    <Label>Rate Plan Add-on's</Label>
                                                    <CustomInput
                                                        type="checkbox"
                                                        checked={tariff.roomSettings.addons}
                                                        name="addons"
                                                        onChange={(event) =>
                                                            handleOptionInputChange(
                                                                event.target.name,
                                                                event.target.value,
                                                                tariff.id
                                                            )
                                                        }
                                                    ></CustomInput>
                                                </Colxx>
                                            )}
                                            <Colxx sm={6} className="mb-3">
                                                <Label>Rate Plan</Label>
                                                <Input
                                                    type="select"
                                                    value={tariff.roomSettings.ratePlanId}
                                                    name="ratePlan"
                                                    onChange={(event) =>
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }
                                                >
                                                    <option value="00000000-0000-0000-0000-000000000000">
                                                        Choose One
                                                    </option>
                                                    {rateList.length > 0 &&
                                                        rateList.map((r, index) => {
                                                            return (
                                                                <option key={index} value={r.id}>
                                                                    {r.name}
                                                                </option>
                                                            );
                                                        })}
                                                </Input>
                                            </Colxx>

                                            {
                                                <Colxx sm={6} className="mb-3">
                                                    <Label>Room</Label>
                                                    <Input
                                                        type="select"
                                                        name="room"
                                                        value={tariff.roomSettings.rooms}
                                                        onChange={(event) =>
                                                            handleOptionInputChange(
                                                                event.target.name,
                                                                event.target.value,
                                                                tariff.id
                                                            )
                                                        }
                                                    >
                                                        {roomList.length > 0 &&
                                                            roomList.map((r, index) => {
                                                                return (
                                                                    <option key={index} value={r.id}>
                                                                        {r.name}
                                                                    </option>
                                                                );
                                                            })}
                                                    </Input>
                                                </Colxx>
                                            }
                                        </Fragment>
                                    ) : null} */}
                                            {voucherData.inventoryOptionLevel && (
                                                <Fragment>
                                                    <Colxx sm={3} className="mb-3">
                                                        <Label>Total Available to Sell</Label>
                                                        <Input
                                                            type="number"
                                                            min={0}
                                                            value={tariff.totalPurchaseLimit}
                                                            name="totalPurchaseLimit"
                                                            onChange={(event) =>
                                                                handleOptionInputChange(
                                                                    event.target.name,
                                                                    event.target.value,
                                                                    tariff.id
                                                                )
                                                            }
                                                        />
                                                    </Colxx>
                                                    <Colxx sm={3} className="mb-3">
                                                        <Label>Order Purchase Limit</Label>
                                                        <Input
                                                            type="number"
                                                            min={0}
                                                            value={tariff.orderPurchaseLimit}
                                                            name="orderPurchaseLimit"
                                                            onChange={(event) =>
                                                                handleOptionInputChange(
                                                                    event.target.name,
                                                                    event.target.value,
                                                                    tariff.id
                                                                )
                                                            }
                                                        />
                                                    </Colxx>
                                                </Fragment>
                                            )}{' '}
                                            <Colxx sm={3} className="mb-3">
                                                <Label>Status</Label>
                                                <Input
                                                    type="select"
                                                    value={tariff.status}
                                                    name="status"
                                                    onChange={(event) =>
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }
                                                >
                                                    <option value="Active">Active</option>
                                                    <option value="Inactive">Inactive</option>
                                                </Input>
                                            </Colxx>
                                            <Colxx sm={3}>
                                                <Label for="displayOrder">Display Order</Label>
                                                <Input
                                                    type="number"
                                                    name="displayOrder"
                                                    min={0}
                                                    value={tariff.displayOrder}
                                                    onChange={(event) =>
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }
                                                />
                                            </Colxx>
                                            <Colxx sm={3} className="mb-3">
                                                <Label>Add Variant Specific Details</Label>
                                                <CustomInput
                                                    type="checkbox"
                                                    id="showDetails"
                                                    checked={tariff.showDetails}
                                                    name="showDetails"
                                                    onChange={(event) => {
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.checked,
                                                            tariff.id
                                                        );
                                                    }
                                                    }
                                                />
                                            </Colxx>


                                            <Colxx sm={3} className="mb-3">
                                                <Label>Redeem Mechanism<span style={{ color: 'red' }}> *</span></Label>
                                                <Input
                                                    type="select"
                                                    value={tariff.roomSettings.redeemOption}
                                                    name="redeemOption"
                                                    onChange={(f) => {
                                                        handleOptionInputChange(
                                                            f.target.name,
                                                            f.target.value,
                                                            tariff.id
                                                        );
                                                    }}
                                                >
                                                    <option
                                                        value="2"
                                                        selected={
                                                            tariff.roomSettings.redeemOption === '2'
                                                                ? true
                                                                : false
                                                        }
                                                    >
                                                        Instructions
                                                    </option>
                                                    <option
                                                        value="3"
                                                        selected={
                                                            tariff.roomSettings.redeemOption === '3'
                                                                ? true
                                                                : false
                                                        }
                                                    >
                                                        aiva Integrations
                                                    </option>
                                                    {amadeus !== undefined && <option
                                                        value="4"
                                                        selected={
                                                            tariff.roomSettings.redeemOption === '4'
                                                                ? true
                                                                : false
                                                        }
                                                    >
                                                        Amadeus Integrations
                                                    </option>}
                                                    {xolaIntegration !== undefined && <option
                                                        value="5"
                                                        selected={
                                                            tariff.roomSettings.redeemOption === '5'
                                                                ? true
                                                                : false
                                                        }
                                                    >
                                                        Xola Integrations
                                                    </option>}
                                                </Input>
                                            </Colxx>
                                            {tariff.roomSettings.redeemOption == 4 && <Colxx sm={3} className="mb-3">
                                                <Label>Promo Code in Amadeus</Label>
                                                <Input
                                                    type="text"
                                                    value={tariff !== undefined && tariff.roomSettings.promoCode}
                                                    name="promoCode"
                                                    onChange={(event) =>
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }
                                                />
                                            </Colxx>}
                                            {tariff.roomSettings.redeemOption == 4 &&
                                                <RoomSettings option={tariff} handleOptionInputChange={handleOptionInputChange} Weekdays={Weekdays} handleAddIncludedItems={handleAddIncludedItems}/>}
                                            {tariff.roomSettings.redeemOption == 5 && xolaIntegration !== undefined && <Colxx sm={3} className="mb-3">
                                                <Label><span className='mt-1'>Applicable coupon </span></Label>
                                                <Input
                                                    type="select"
                                                    value={tariff.roomSettings.couponId}
                                                    name="couponId"
                                                    id='couponId'
                                                    onChange={(event) => {
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }}
                                                >
                                                    <option value="-1">Select One</option>
                                                    {couponList !==undefined && couponList.length > 0 && couponList.map((m) =>
                                                        <option value={m.id}>{m.name}</option>
                                                    )}
                                                </Input>
                                            </Colxx>}
                                        </Row>
                                        {tariff.currencies.length > 0 && tariff.currencies.map((m, index) =>
                                            <Row className="mb-2">
                                                <Colxx sm={3} className="mb-3">
                                                    <Label>Retail Price<span style={{ color: 'red' }}> *</span></Label>
                                                    <InputGroup>
                                                        <Input
                                                            type="number"
                                                            min={0}
                                                            value={m.price}
                                                            onChange={(e) => handleCurrencyPrice(e, index, tariff.id)}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <Input
                                                                type="select"
                                                                value={m.currency}
                                                                name="type"
                                                                onChange={(e) => handleCurrency(e, index, tariff.id)}
                                                            >
                                                                {StandaloneCurrency.map((elem, index) => (
                                                                    <option value={elem.code}>{elem.code}</option>
                                                                ))}
                                                            </Input>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </Colxx>
                                                <Colxx sm={3} className="mb-3">
                                                    <Label>Discount<span style={{ color: 'red' }}> *</span></Label>
                                                    <Input
                                                        type="number"
                                                        min={0}
                                                        value={m.discount}
                                                        onChange={(e) => handleCurrencyDiscount(e, index, tariff.id)}
                                                    />
                                                </Colxx>
                                                <Colxx sm={3} className="mb-3">
                                                    <Label>Price After Discount<span style={{ color: 'red' }}> *</span></Label>
                                                    <Input
                                                        type="number"
                                                        disabled={true}
                                                        value={m.discountedPrice}
                                                    />
                                                </Colxx>
                                                <Colxx sm={2} className="mb-3">
                                                    <Label>Tax Amount<span style={{ color: 'red' }}> *</span></Label>
                                                    <Input
                                                        type="text"
                                                        disabled={true}
                                                        value={voucherData.taxAmount}
                                                    />
                                                </Colxx>
                                                <Colxx sm={1} className="mb-3 mt-3">
                                                    <Button color="danger" onClick={() => handleRemoveCurrencies(index, tariff.id)}>
                                                        X
                                                    </Button>
                                                </Colxx>
                                            </Row>
                                        )}
                                        <Row className="mb-1">
                                            <Button color="secondary" onClick={() => handleAddCurrencies(tariff.id)}>
                                                Add Currencies
                                            </Button>
                                        </Row>
                                        <hr></hr>
                                        <Row>
                                            {voucherData.redeemOption !== 'BookMeBob' && (
                                                <Colxx sm={6} className="mb-3 d-none">
                                                    <Label>Instructions</Label>

                                                    <ReactQuill
                                                        theme="snow"
                                                        value={getLocalStatement(tariff.instruction)}
                                                        onChange={(content, delta, source) => {
                                                            handleInstruction(source, content, tariff.id);
                                                        }}
                                                        modules={quillModules}
                                                        formats={quillFormats}
                                                        name="instruction"
                                                    />
                                                </Colxx>
                                            )}
                                            {tariff.showDetails && (
                                                <Colxx sm={6} className="mb-3">
                                                    <Label>Option Details</Label>
                                                    <ReactQuill
                                                        theme="snow"
                                                        value={getLocalStatement(tariff.details)}
                                                        onChange={(content, delta, source) => {
                                                            handleDetails(source, content, tariff.id);
                                                        }}
                                                        modules={quillModules}
                                                        formats={quillFormats}
                                                        name="details"
                                                    />
                                                </Colxx>
                                            )}
                                        </Row>
                                    </Fragment>

                                ))
                            : null}
                    </Fragment>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => { handleSubmit(); }}>
                        Save
                    </Button>
                    <Button
                        color="secondary"
                        onClick={() => {
                            setVoucherData({ ...voucherData, sellingOptions: [] });
                            toggle();
                        }}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            {/* {!update && handleAddOptions()} */}
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId,
        locale,
    };
};
export default injectIntl(connect(mapStateToProps)(BuyOptionForm));
